import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// CSS
import * as styles from "./BookConsultation.module.css";

const BookConsultationComponent = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <>
      <div
        ref={ref}
        className={`container-fluid scroll_animate ${inView && "inview"} ${
          styles.diabConsLp__bookCons__cont
        }`}
      >
        <div className={`row`}>
          <div
            className={`col-12 col-lg-6 col-md-6 order-2 order-md-1 order-lg-1`}
          >
            <div
              className={`d-flex align-items-center justify-content-md-evenly justify-content-around ${styles.diabConsLp__bookCons__leftCol}`}
            >
              <div className={styles.diabConsLp__bookCons__leftCont}>
                <p>
                  Whole Body <br></br>Digital Twin
                </p>
                <StaticImage
                  src="../../../../images/LandingPage/diabetes_conslt_lp_icn1.png"
                  alt="banner_image"
                  className="img-fluid"
                  placeholder="blurred"
                  quality={90}
                />
              </div>
              <div className={styles.diabConsLp__bookCons__leftCont}>
                <p>
                  Twin <br></br>Mobile App
                </p>
                <StaticImage
                  src="../../../../images/LandingPage/diabetes_conslt_lp_icn2.png"
                  alt="banner_image"
                  className="img-fluid"
                  placeholder="blurred"
                  quality={90}
                />
              </div>
            </div>
            <div
              className={`d-flex align-items-center justify-content-md-evenly justify-content-around mt-5`}
            >
              <div className={styles.diabConsLp__bookCons__leftCont}>
                <p>
                  Regular Calls with<br></br> Health Coach
                </p>
                <StaticImage
                  src="../../../../images/LandingPage/diabetes_conslt_lp_icn3.png"
                  alt="banner_image"
                  className="img-fluid ms-4"
                  placeholder="blurred"
                  quality={90}
                />
              </div>
              <div className={styles.diabConsLp__bookCons__leftCont}>
                <p>
                  24x7 Health<br></br> Monitoring
                </p>
                <StaticImage
                  src="../../../../images/LandingPage/diabetes_conslt_lp_icn4.png"
                  alt="banner_image"
                  className="img-fluid"
                  placeholder="blurred"
                  quality={90}
                />
              </div>
            </div>
          </div>
          <div
            className={`col-12 col-lg-6 col-md-6 order-1 order-md-2 order-lg-2`}
          >
            <div>
              <div className={styles.diabConsLp__bookCons__rightCont__hdng}>
                <h3>Book a one on one consultation to know</h3>
              </div>
              <ul className={styles.diabConsLp__bookCons__rightCont__para}>
                <li>What is diabetes reversal and how can it be sustained?</li>
                <li>How to precisely heal the root cause of diabetes?</li>
                <li>
                  How to lower sugar levels through custom diets and lifestyle
                  changes?
                </li>
                <li>
                  How our certified <strong>“Whole Body Digital Twin”</strong>{" "}
                  technology can help in diabetes
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookConsultationComponent;
